import { Currency } from '@/core/currency/interfaces';

const AZN: Currency = {
    name: 'Azerbaijani Manat',
    demonym: 'Azerbaijani',
    majorSingle: 'Manat',
    majorPlural: 'Manat',
    codeNumeric: '944',
    symbol: 'ман',
    symbolNative: '₼',
    minorSingle: 'Qapik',
    minorPlural: 'Qapik',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'AZN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default AZN;
